module.exports = __webpack_public_path__ + "media/images/ibjjf/academy_registration_informations/competitors_draw-0ccdbb618a37f803ce77112860fdefb6.svg";